import { IChartContainer } from "../models/base/chart-container.interface";
import { DateHelpers } from "./date-helpers";
declare const window: any;

export class TraceLoggingHelpers {
    private traceLoggingEnabled = false;
    private base: IChartContainer;
    constructor(base: IChartContainer, traceLoggingEnabled: boolean) {
        this.base = base;
        this.traceLoggingEnabled = traceLoggingEnabled;
        TraceLoggingHelpers.instance = this;
    }

    private static instance: TraceLoggingHelpers | null = null;
    public static log(message: string, extraParameters?: any) {
        const traceLoggingEnabled = TraceLoggingHelpers.instance?.traceLoggingEnabled ?? false;
        if (traceLoggingEnabled || (TraceLoggingHelpers.instance && !TraceLoggingHelpers.instance.base.marketingWebChartMode && window.traceLoggingEnabled)) {
            if (!this.instance.base.marketingWebChartMode && window.traceLoggingEnabled) {
                this.instance.base.handleTraceLogging();
            }

            const timestamp = DateHelpers.getTraceLoggingTimeStamp();
            console.log(timestamp, 'CHART TRACELOGGING,', message, extraParameters ? extraParameters : '');
        }
    }

    public static logWarn(message: string, extraParameters?: any) {
        const timestamp = DateHelpers.getTraceLoggingTimeStamp();
        console.warn(timestamp, 'API TRACELOGGING,', message, extraParameters);
    }

    public static logError(message: string, extraParameters?: any) {
        const timestamp = DateHelpers.getTraceLoggingTimeStamp();
        console.error(timestamp, 'API TRACELOGGING,', message, extraParameters);
    }
}